export var SharedCalendarStrings = {
    title: function () { return 'Group Orders'; },
    description: function () {
        return "Join your team\u2019s group order by adding your favorite items. You can start adding items up to 24 hours before checkout time, and your administrator will take care of the final checkout once everyone's done.";
    },
    headerSubtitle: function () { return 'Admin Portal for'; },
};
